import 'uno.css';
import '@assets/css/index.css';

import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from './components/ErrorBoundary';

// Helper global para normalizar una URL a su pathname
function normalizeToPathname(input) {
  try {
    if (!input || typeof input !== 'string') return '';
    const u = input.startsWith('http')
      ? new URL(input)
      : new URL(input, window.location.origin);
    return u.pathname || '/';
  } catch {
    const s = String(input || '');
    const base = s.split('?')[0].split('#')[0];
    return base.startsWith('/') ? base : '/' + base;
  }
}
window.normalizeToPathname = normalizeToPathname;

// 🔀 Mapeo de apps por nombre
const AppMap = {
  cliente: lazy(() => import('./AppCliente')),
  vendedor: lazy(() => import('./AppVendedor')),
  admin: lazy(() => import('./AppAdministrador')),
};

// 📦 Rutas asociadas a cada app
const AppRoutes = [
  { prefix: '/admin', component: AppMap.admin },
  { prefix: '/vendedor', component: AppMap.vendedor },
];

// 🧠 Selección dinámica de la app
const pathname = window.location.pathname;
const AppToRender =
  AppRoutes.find(({ prefix }) => pathname.startsWith(prefix))?.component || AppMap.cliente;

// 💡 Fallback visual durante carga
const AppLoader = () => (
  <div
    className="text-center text-gray-500 mt-10"
    role="status"
    aria-live="polite"
  >
    Cargando aplicación...
  </div>
);

// 🏁 Inicio de la aplicación
const container = document.getElementById('root');
if (!container) {
  throw new Error('❌ No se encontró el elemento #root en el DOM');
}

createRoot(container).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<AppLoader />}>
        <AppToRender />
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);
